import type { Dispatch, SetStateAction } from "react";
import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { communityPlanAddonApi } from "@/react/api/communityPlanAddonApi";
import type { AddOnQuantity } from "@/react/types";
import { useToast } from "@circle-react-uikit/ToastV2";

interface ServerError {
  errors?: unknown;
  title: string;
}

interface ApiError {
  errorDetails?: unknown;
  message: string;
}

interface UseCommunityPlanAddonApiProps {
  handleOnSuccess?: () => void;
  onCloseModal?: () => void;
  refetchCurrentPlan?: () => void;
  setServerErrors?: Dispatch<SetStateAction<ServerError | undefined>>;
}

export const useCommunityPlanAddonApi = ({
  handleOnSuccess,
  setServerErrors,
  onCloseModal,
  refetchCurrentPlan,
}: UseCommunityPlanAddonApiProps) => {
  const toast = useToast();

  const handleAddonsMutation = useMutation<
    void,
    ApiError,
    Record<string, AddOnQuantity>
  >(formData => communityPlanAddonApi.create(formData), {
    onSuccess: () => {
      if (handleOnSuccess) {
        handleOnSuccess();
      } else {
        refetchCurrentPlan?.();
        toast.success(t("settings.billing.add_ons.changes_succeeded"));
        onCloseModal?.();
      }
    },
    onError: (responseError: { message: string; errorDetails?: unknown }) => {
      console.error(responseError);
      setServerErrors &&
        setServerErrors({
          title: responseError?.message,
          errors: responseError?.errorDetails,
        });
    },
  });

  return {
    handleAddonsMutation,
  };
};
